// src/components/Logs/LogForenseTable.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Chip
} from '@mui/material';
import { formatLogDate } from '../../utils/logFormatters';

const LogForenseTable = ({ logs = [] }) => {
  const formatDate = (date) => {
    try {
      if (!date) return '-';
      const formattedDate = formatLogDate(date);
      return formattedDate;
    } catch (error) {
      console.error('Erro ao formatar data:', date, error);
      return date || '-';
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Data/Hora</TableCell>
            <TableCell>Usuário</TableCell>
            <TableCell>Ação</TableCell>
            <TableCell>IP</TableCell>
            <TableCell>Detalhes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>{formatDate(log.created_at || log.createdAt)}</TableCell>
              <TableCell>{log.usuario?.nome || 'Sistema'}</TableCell>
              <TableCell>
                <Chip
                  label={log.acao}
                  color="error"
                  variant="outlined"
                  size="small"
                />
              </TableCell>
              <TableCell>{log.ip || '-'}</TableCell>
              <TableCell>
                <pre style={{ margin: 0, fontSize: '0.875rem' }}>
                  {JSON.stringify(log.detalhes, null, 2)}
                </pre>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

LogForenseTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      created_at: PropTypes.string, // Aceitar created_at
      createdAt: PropTypes.string,  // Aceitar createdAt
      usuario: PropTypes.shape({
        nome: PropTypes.string
      }),
      acao: PropTypes.string.isRequired,
      ip: PropTypes.string,
      detalhes: PropTypes.object
    })
  ).isRequired
};

export default LogForenseTable;
